import { Store } from 'src/store/index';

const getEncryptedDesignId = (store: Store) => store.design.encryptedDesignId;

export default getEncryptedDesignId;
